"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconList = exports.iconMap = void 0;
const md_1 = require("react-icons/md");
const si_1 = require("react-icons/si");
const tb_1 = require("react-icons/tb");
exports.iconMap = {
    // Edition
    'add': md_1.MdAdd,
    'delete': md_1.MdDelete,
    'edit': md_1.MdEdit,
    'help': md_1.MdHelpOutline,
    // In game
    'gamepad': md_1.MdVideogameAsset,
    "play": md_1.MdPlayArrow,
    'playCircle': md_1.MdPlayCircleOutline,
    'home': md_1.MdHome,
    'restart': md_1.MdRestartAlt,
    'back': md_1.MdKeyboardArrowLeft,
    'return': md_1.MdKeyboardReturn,
    'next': md_1.MdNextPlan,
    'pause': md_1.MdPause,
    // System
    'settings': md_1.MdSettings,
    'search': md_1.MdSearch,
    'volumeOn': md_1.MdVolumeUp,
    'volumeOff': md_1.MdVolumeOff,
    'fullscreenOn': md_1.MdFullscreen,
    'fullscreenOff': md_1.MdFullscreenExit,
    'favoriteOn': md_1.MdFavorite,
    'favoriteOff': md_1.MdFavoriteBorder,
    'qrcode': md_1.MdQrCode,
    'screenRotation': md_1.MdScreenRotation,
    'people': md_1.MdGroup,
    'time': md_1.MdWatchLater,
    'error': md_1.MdError,
    'press': tb_1.TbHandClick,
    // Other
    'emoji': md_1.MdEmojiEmotions,
    'discord': si_1.SiDiscord,
};
exports.iconList = Object.keys(exports.iconMap);
//# sourceMappingURL=icon_list.js.map